module.exports = __webpack_public_path__ + "img/sensor.054eeac6.png";